<template>
  <div v-if="mode" class="so_banner" role="status">
    <span class="so_banner_icon" aria-hidden="true">i</span>
    <span class="so_banner_text">
      <template v-if="mode === 'topup'">
        <strong>{{ $t("self_onboard.banner_topup_title") }}</strong>
        {{ $t("self_onboard.banner_topup_desc", { min: min }) }}
      </template>
      <template v-else>
        <strong>{{ $t("self_onboard.banner_start_title") }}</strong>
        {{ $t("self_onboard.banner_start_desc", { min: min }) }}
      </template>
    </span>
    <router-link v-if="mode === 'topup'" :to="{ name: 'emp-topup', query: { onboard: '1' } }" class="so_banner_cta">
      {{ $t("self_onboard.go_topup") }}
    </router-link>
    <router-link v-else :to="profilePath" class="so_banner_cta">
      {{ $t("self_onboard.start_now") }}
    </router-link>
  </div>
</template>

<script>
import ApiService from "../../../api/api.service";
import Bus from "../../../event-bus";

// Slim reminder across the employer portal (EMPLOYER_SELF_ONBOARDING_PLAN.md) so an
// employer who has left the profile page can still find the next step:
//   agreement accepted, not topped up → "One step left … Top up now"
//   eligible, not started (and not "speak to Sales") → "Get approved today … Start now"
// Hidden on the profile page (the full card is there) and on the onboarding Top Up page.
const PROFILE_PATH = "/v2/employer/employer-profile";

export default {
  name: "SelfOnboardBanner",
  data() {
    return { st: null };
  },
  computed: {
    profilePath() {
      return PROFILE_PATH;
    },
    min() {
      const sign = this.$profile && this.$profile.currencySign ? this.$profile.currencySign : "$";
      return sign + Number((this.st && this.st.min_top_up_amount) || 0);
    },
    hiddenHere() {
      const p = this.$route.path;
      return p === PROFILE_PATH || (p === "/v2/employer/topup" && this.$route.query.onboard === "1");
    },
    dismissed() {
      try {
        const u = this.$store.getters.currentUser;
        return window.localStorage.getItem("so_card_dismissed_" + (u ? u.id : "")) === "1";
      } catch (e) {
        return false;
      }
    },
    mode() {
      if (!this.st || !this.st.show_card || this.hiddenHere) return null;
      if (this.st.agreement_accepted) return "topup";
      if (this.dismissed) return null;
      return "start";
    },
  },
  watch: {
    // Re-check only while the banner applies (e.g. after accepting, after approval),
    // so other employers don't make a call on every navigation.
    $route() {
      if (this.st && this.st.show_card) this.refresh();
    },
  },
  methods: {
    refresh() {
      ApiService.setHeader();
      ApiService.get("/api/self-onboarding/status").then((res) => {
        const body = res && res.data;
        if (!body || !body.success) return;
        const wasShowing = this.st && this.st.show_card;
        this.st = body.data;
        // Approved since the last check (e.g. admin approved a PayNow top-up): refresh the
        // navbar so the Temp Staff menu appears without a hard refresh.
        if (wasShowing && !this.st.show_card && this.st.account_status !== "pending") {
          Bus.$emit("refresh_employer_status");
        }
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.so_banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  background: #eaf2ff;
  border: 1px solid #b9d3fb;
  border-radius: 10px;
  padding: 10px 14px;
  margin: 0 0 18px;
  font-size: 14px;
  line-height: 1.45;
  color: #1e3a6e;
}
.so_banner_icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #4c8bf5;
  color: #fff;
  font-weight: 800;
  font-size: 13px;
  font-style: italic;
  display: flex;
  align-items: center;
  justify-content: center;
}
.so_banner_text { flex: 1 1 320px; min-width: 0; }
.so_banner_cta {
  flex-shrink: 0;
  background: #4c8bf5;
  color: #fff !important;
  font-weight: 700;
  border-radius: 8px;
  padding: 0 16px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  text-decoration: none !important;
}
.so_banner_cta:hover { background: #2f6fdb; }
</style>
